var $ = require('jquery');
export default {
	props: ['alertas'],
	data() {
		return {
			time: null
		};
	},
	watch: {
		alertas: function() {
			var that = this;
			if (this.alertas.length > 0) {
				clearTimeout(this.time);

				$(".alerts").fadeIn("slow");

				this.time = setTimeout(function() {
					$(".alerts").fadeOut("slow");
					this.alertas = [];
				}, 7500);
			}
		}
	},
	methods: {
		beforeDestroy: function(index) {
			var that = this;
			$('alerts-' + index).addClass('alerts-leave-to');

			clearTimeout(this.time);

			this.time = setTimeout(function() {
				$(".alerts").fadeOut("slow");
				if (typeof that.alertas !== 'undefined') {
					that.alertas.splice(index, 1);
				}
			}, 0);
		}
	},
};